import { useTranslation } from "react-i18next";

const NoTopicsMessage = () => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col justify-center items-center gap-1 py-6">
            <div className="text-lg text-stone-darkest font-bold tracking-[-0.36px]">
                {t("searchForm.popup.noResultsLabel.line1")}
            </div>

            <div className="text-base text-stone-vibrant font-medium-light tracking-[-0.32px]">
                {t("searchForm.popup.noResultsLabel.line2")}
            </div>
        </div>
    );
}

export default NoTopicsMessage;
